<template lang="pug">
  div
    b-row.mb-2(align-h="between")
      b-col.mb-2
        h3.d-inline Solicitudes de Asignación
    b-form
      b-form-row.mb-2
        b-col(cols="12" md="auto")
          b-form-datepicker(
            v-model="backendFilters.date"
            :date-format-options="{ year: 'numeric', month: 'numeric', day: 'numeric' }"
            placeholder="Fecha..."
            style="min-width: 150px;"
            reset-button
          )
        b-col(cols="12" md="auto")
          b-form-select(
            v-model="backendFilters.items__status"
            placeholder="Estado..."
          )
            b-form-select-option(:value="null") Todos
            b-form-select-option(:value="ASSIGNMENT_ITEM_STATUS.PENDING") {{ ASSIGNMENT_ITEM_STATUS_TEXT[ASSIGNMENT_ITEM_STATUS.PENDING] }}
            b-form-select-option(:value="ASSIGNMENT_ITEM_STATUS.ACCEPTED") {{ ASSIGNMENT_ITEM_STATUS_TEXT[ASSIGNMENT_ITEM_STATUS.ACCEPTED] }}
            b-form-select-option(:value="ASSIGNMENT_ITEM_STATUS.REJECTED") {{ ASSIGNMENT_ITEM_STATUS_TEXT[ASSIGNMENT_ITEM_STATUS.REJECTED] }}
        b-col(cols="12" md="auto")
          v-select(
            v-model="backendFilters.driverId"
            :options="driversOptions"
            label="text"
            :reduce="option => option.value"
            placeholder="Conductor..."
            style="min-width: 200px;"
          )
        b-col(cols="12" md="auto")
          b-button(variant="primary" @click="fetchData" block) Filtrar

    b-table(:fields="fields" :items="requestsData" responsive striped primary-key="id")
      template(#cell(createdAt)="{value}")
        div {{ formatDate(value) }}
      template(#cell(actions)="row")
        .table-actions
          b-button.table-btn-icon(@click="toggleDetails(row.item)")
            span.material-icons {{ row.item._showDetails ? 'visibility_off' : 'visibility' }}
          b-button.table-btn-icon(v-if="getStatusCounters(row.item.items).PENDING > 0" variant="success" @click="approveAll(row.item)")
            span.material-icons check
          b-button.table-btn-icon(v-if="getStatusCounters(row.item.items).PENDING > 0" variant="danger" @click="rejectAll(row.item)")
            span.material-icons close
      template(#cell(statusCounters)="{item}")
        div(:class="ASSIGNMENT_ITEM_STATUS.ACCEPTED") {{ ASSIGNMENT_ITEM_STATUS_TEXT[ASSIGNMENT_ITEM_STATUS.ACCEPTED] }}: {{ getStatusCounters(item.items).ACCEPTED || 0 }}
        div(:class="ASSIGNMENT_ITEM_STATUS.REJECTED") {{ ASSIGNMENT_ITEM_STATUS_TEXT[ASSIGNMENT_ITEM_STATUS.REJECTED] }}: {{ getStatusCounters(item.items).REJECTED || 0 }}
        div(:class="ASSIGNMENT_ITEM_STATUS.PENDING") {{ ASSIGNMENT_ITEM_STATUS_TEXT[ASSIGNMENT_ITEM_STATUS.PENDING] }}: {{ getStatusCounters(item.items).PENDING || 0 }}
        
      template(#row-details="row")
        hr
        div(v-if="getPhotoItems(row.item.items).length")
          .section-title Solicitudes por foto
          .photo-grid
            RequestItemImageCard(
              v-for="requestItem in getPhotoItems(row.item.items)" 
              :key="requestItem.id" 
              :requestItem="requestItem"
              @approve="approveRequestItem"
              @reject="rejectRequestItem"
              @openImage="openImageModal"
            )
        div(v-if="getScannedItems(row.item.items).length")
          .section-title Solicitudes por escaneo
          b-table(
            :items="getScannedItems(row.item.items)"
            :fields="subTableFields"
            responsive
            striped
          )
            template(#cell(status)="{item}")
              StatusBadge(:status="item.delivery.status")
            template(#cell(actions)="{item}")
              .table-actions
                b-button.table-btn-icon(v-if="getIsPending(item)" @click="approveRequestItem(item)" variant="success")
                  span.material-icons check
                b-button.table-btn-icon(v-if="getIsPending(item)" @click="rejectRequestItem(item)" variant="danger")
                  span.material-icons close
                b-button.table-btn-icon(@click="openDeliveryForm(item.delivery)" variant="primary")
                  span.material-icons edit
    b-pagination(
      v-model="currentPage"
      :total-rows="totalRows"
      :per-page="perPage"
      align="center"
      @input="fetchData"
    )

    ImageZoomViewer(
      :src="selectedRequestItem ? selectedRequestItem.photoUrl : ''"
      :visible="showImageViewer"
      @close="closeImageViewer"
    )
      template(#footer v-if="selectedRequestItem && selectedRequestItem.status === ASSIGNMENT_ITEM_STATUS.PENDING")
        b-button.mr-2(variant="danger" @click="rejectRequestItem(selectedRequestItem)") Rechazar
        b-button(variant="success" @click="approveRequestItem(selectedRequestItem)") Aprobar
    DeliveryFormModal(ref='deliveryFormModal' @done="fetchData({ keepExpanded: true })")
</template>

<script>
import { mapActions } from 'vuex'
import moment from 'moment-timezone'
import MakeToastMixin from '../mixins/MakeToastMixin'
import { ASSIGNMENT_ITEM_STATUS, ASSIGNMENT_ITEM_STATUS_TEXT, ASSIGNMENT_ITEM_STATUS_VARIANT } from '@/constants/assignmentItemStatus'
import StatusBadge from '@/components/common/StatusBadge.vue'
import vSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import RequestItemImageCard from './RequestItemImageCard.vue'
import ImageZoomViewer from './ImageZoomViewer.vue'
import DeliveryFormModal from '../delivery/DeliveryFormModal.vue'
import { debounce } from 'lodash'

export default {
  mixins: [MakeToastMixin],
  components: {
    StatusBadge,
    vSelect,
    RequestItemImageCard,
    ImageZoomViewer,
    DeliveryFormModal
  },
  data() {
    return {
      ASSIGNMENT_ITEM_STATUS_TEXT,
      ASSIGNMENT_ITEM_STATUS_VARIANT,
      ASSIGNMENT_ITEM_STATUS,
      backendFilters: {
        items__status: null,
        date: moment().format('YYYY-MM-DD'),
        driverId: null
      },
      expandedRequests: {},
      scannedItems: [],
      photoItems: [],
      selectedRequestItem: null,
      showImageViewer: false,
      driversOptions: [],
      requests: [],
      totalRows: 0,
      currentPage: 1,
      perPage: 30,
      fields: [
        { label: 'Fecha Solicitud', key: 'createdAt' },
        { label: 'Cod. Conductor', key: 'driver.codeDriver' },
        { label: 'Conductor', key: 'driverName' },
        { label: 'Total', key: 'items.length' },
        { label: 'Estado', key: 'statusCounters' },
        { label: 'Acciones', key: 'actions' }
      ],
      subTableFields: [
        { label: 'Fecha', key: 'formatDate' },
        { label: 'Código', key: 'delivery.drivInCode' },
        { label: 'Comentario Interno', key: 'delivery.internalComment' },
        { label: 'Tienda', key: 'delivery.customerName' },
        { label: 'Destinatario', key: 'delivery.finalCustomer' },
        { label: 'Teléfono', key: 'delivery.contactPhone' },
        { label: 'Dirección', key: 'delivery.address' },
        { label: 'Comuna', key: 'delivery.commune' },
        { label: 'Observaciones', key: 'delivery.observations' },
        { label: 'Cod. Conductor', key: 'delivery.driver.codeDriver' },
        { label: 'Conductor Actual', key: 'driverName' },
        { label: 'Tags', key: 'delivery.tagsName' },
        { label: 'Cantidad de Bultos', key: 'delivery.bundleQuantity' },
        { label: 'Estado', key: 'status' },
        { label: 'Revisado Por', key: 'reviewerName' },
        { label: 'Fecha Revisión', key: 'formattedReviewDate' },
        { label: 'Acciones', key: 'actions' }
      ]
    }
  },
  methods: {
    ...mapActions('assignment', [
      'listDriverAssignmentRequests',
      'acceptAssignmentRequestItem',
      'rejectAssignmentRequestItem',
      'getAssignmentRequestItemCounters',
      'getAssignmentRequestItem'
    ]),
    ...mapActions(['listDriver']),
    toggleDetails(item) {
      console.log(item)
      item._showDetails = !item._showDetails
    },
    openDeliveryForm(delivery) {
      this.$refs.deliveryFormModal.openModal(delivery)
    },
    formatRequestItemRow(item) {
      if (!item.delivery) {
        return item
      }
      const variantByStatus = {
        [this.ASSIGNMENT_ITEM_STATUS.PENDING]: 'warning',
        [this.ASSIGNMENT_ITEM_STATUS.ACCEPTED]: 'success',
        [this.ASSIGNMENT_ITEM_STATUS.REJECTED]: 'danger',
      }
      return Object.assign(item, {
        formatDate: moment(item.delivery?.date).format('DD-MM-YYYY'),
        driverName: item.delivery?.driver ? `${item.delivery.driver.name} ${item.delivery.driver.lastName}` : 'Sin conductor',
        _rowVariant: variantByStatus[item.status],
        formattedReviewDate: item.reviewedAt ? moment(item.reviewedAt).format('DD-MM-YYYY HH:mm') : '',
        reviewerName: item.reviewer ? `${item.reviewer.name} ${item.reviewer.lastName}` : ''
      })
    },
    formatRequestRow(request) {
      return {
        ...request,
        driverName: request.driver ? `${request.driver.name} ${request.driver.lastName}` : 'N/A',
        reviewer: request.reviewer ? `${request.reviewer.name} ${request.reviewer.lastName}` : '-',
        _showDetails: this.expandedRequests[request.id] || false
      }
    },
    getIsPending(item) {
      return item.status === this.ASSIGNMENT_ITEM_STATUS.PENDING
    },
    getScannedItems(requestItems) {
      return requestItems.filter(item => item.delivery).map(item => this.formatRequestItemRow(item))
    },
    getPhotoItems(requestItems) {
      return requestItems.filter(item => !item.delivery)
    },
    async fetchDrivers() {
      const response = await this.listDriver()
      this.driversOptions =
        [
          {
            text: 'Todos los conductores',
            value: null
          },
          ...response.data.map(driver => ({
            text: `${driver.name} ${driver.lastName}`,
            value: driver.id
          }))
        ]
    },
    getStatusCounters(requestItems) {
      return requestItems.reduce((acc, item) => {
        acc[item.status] = (acc[item.status] || 0) + 1
        return acc
      }, {})
    },
    getPendingItems(requestItems) {
      return requestItems.filter(item => item.status === this.ASSIGNMENT_ITEM_STATUS.PENDING)
    },
    async fetchData({ keepExpanded = false } = {}) {
      if (!keepExpanded) {
        this.expandedRequests = {}
      } else {
        this.expandedRequests = this.requests.reduce((acc, request) => {
          acc[request.id] = true
          return acc
        }, {})
      }
      const filters = {
        ...this.backendFilters,
        page: this.currentPage,
        pageSize: this.perPage
      }

      const response = await this.listDriverAssignmentRequests({
        params: filters
      })

      if (response.status === 200) {
        this.requests = response.data.rows
        this.totalRows = response.data.count
      } else {
        this.makeDangerToast('Error al cargar solicitudes')
      }

      // Obtener y actualizar contadores
      await this.fetchCounters()
    },
    async fetchCounters() {
      try {
        const queryParams = {}
        if (this.backendFilters.date) queryParams.date = this.backendFilters.date
        if (this.backendFilters.driverId) queryParams.driverId = this.backendFilters.driverId
        if (this.backendFilters.items__status) queryParams.status = this.backendFilters.items__status

        const res = await this.getAssignmentRequestItemCounters({
          params: queryParams
        })

        if (res.status === 200) {
          this.$store.commit('assignment/SET_STATUS_COUNTERS', res.data)
        }
      } catch (err) {
        console.error("Error obteniendo contadores de ítems", err)
      }
    },
    formatDate(date) {
      return moment(date).format('DD-MM-YYYY HH:mm')
    },
    openImageModal(requestItem) {
      this.selectedRequestItem = requestItem
      this.showImageViewer = true
    },
    closeImageViewer() {
      this.showImageViewer = false
    },
    async approveRequestItem(item) {
      try {
        const response = await this.acceptAssignmentRequestItem({ id: item.id })
        if (response.status === 200) {
          const data = response.data
          Object.assign(item, this.formatRequestItemRow(data))
          this.fetchCounters()
        } else {
          this.$bvToast.toast(response.data.message, {
            title: 'Error',
            variant: 'danger'
          })
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Error al aprobar solicitud'
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger'
        })
      }
    },
    async rejectRequestItem(item) {
      try {
        const response = await this.rejectAssignmentRequestItem({ id: item.id })
        if (response.status === 200) {
          Object.assign(item, this.formatRequestItemRow(response.data))
          this.fetchCounters()
        } else {
          this.$bvToast.toast(response.data.message, {
            title: 'Error',
            variant: 'danger'
          })
        }
      } catch (error) {
        const errorMessage = error.response?.data?.message || 'Error al rechazar solicitud'
        this.$bvToast.toast(errorMessage, {
          title: 'Error',
          variant: 'danger'
        })
      }
    },
    async approveAll(request) {
      const pendingItems = request.items.filter(item => item.status === this.ASSIGNMENT_ITEM_STATUS.PENDING)

      const ok = await this.$bvModal.msgBoxConfirm(`¿Estás seguro de asignar ${pendingItems.length} paquetes al conductor ${request.driver.name} ${request.driver.lastName}?`, {
        title: 'Confirmar',
        okVariant: 'success',
        cancelVariant: 'danger'
      })
      if (!ok) {
        return
      }

      pendingItems.forEach(item => {
        this.approveRequestItem(item)
      })
    },
    async rejectAll(request) {
      const pendingItems = request.items.filter(item => item.status === this.ASSIGNMENT_ITEM_STATUS.PENDING)

      const ok = await this.$bvModal.msgBoxConfirm(`¿Estás seguro de rechazar ${pendingItems.length} paquetes al conductor ${request.driver.name} ${request.driver.lastName}?`, {
        title: 'Confirmar',
        okVariant: 'success',
        cancelVariant: 'danger'
      })
      if (!ok) {
        return
      }

      pendingItems.forEach(item => {
        this.rejectRequestItem(item)
      })
    }
  },
  computed: {
    requestsData() {
      return this.requests.map(req => this.formatRequestRow(req))
    }
  },
  mounted() {
    this.fetchCounters = debounce(this.fetchCounters, 500)
    this.fetchData()
    this.fetchDrivers()
  }
}
</script>

<style scoped>
.detail-header {
  font-weight: 600;
  margin-bottom: 1rem;
}

.section-title {
  font-weight: 600;
  margin-bottom: 1rem;
}

.photo-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  margin-bottom: 1rem;
}


.delivery-cards-grid {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1rem 0;
}

.table-actions {
  display: flex;
  gap: 1rem;
}

.table-btn-icon {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
